const shop_currency = __rt.money_format.replace("{{amount}}", "");

jQuery(function ($) {
  $(".sidebar-toggle").click(function (event) {
    if (!$("body").hasClass("canvas-left")) {
      $("body").addClass("mobile-canvas-shown");
      $("body").addClass("canvas-left", function () {
        setTimeout(function () {
          $(document).one("click", function (e) {
            var target = e.target;
            if (
              !$(target).is(".canvas-left .block") &&
              !$(target).parents().is(".canvas-left .canvas-inner")
            ) {
              $("body").removeClass("canvas-left");
              $("body").removeClass("mobile-canvas-shown");
            }
          });
          $(".block-title .apply-filter-mob .close-btn-mob").click(function (
            e
          ) {
            $("body").removeClass("canvas-left");
            $("body").removeClass("mobile-canvas-shown");
          });
        }, 111);
      });
    } else {
      $("body").removeClass("canvas-left");
      $("body").removeClass("mobile-canvas-shown");
    }
  });

  // sticky filter on mobile
  if ($(".toolbar").length > 0) {
    var init_filter_sticky = function () {
      var $obj = $(".toolbar.top_toolbar");
      if (!$obj.prev(".filter-placeholder").length) {
        $('<div class="filter-placeholder m-0"></div>').insertBefore($obj);
      }
      var sticky_height = 0;
      if ($(".header-container.sticky-header").length > 0) {
        sticky_height = $(".header-container.sticky-header").outerHeight();
      }
      var $ph = $obj.prev(".filter-placeholder"),
        scrollTop = $(window).scrollTop(),
        offset = sticky_height;
      if ($ph.offset().top <= scrollTop + offset) {
        $ph.css(
          "height",
          $obj.outerHeight() + parseInt($obj.css("margin-bottom"))
        );
        $obj.addClass("sticky").css("top", offset);
      } else {
        $ph.css("height", "");
        $obj.removeClass("sticky");
      }
    };
    if (window.innerWidth < 992) {
      window.removeEventListener("scroll", init_filter_sticky);
      window.addEventListener("scroll", init_filter_sticky, { passive: true });
      init_filter_sticky();
    }
    $(window).on("resize", function () {
      if (window.innerWidth < 992) {
        window.removeEventListener("scroll", init_filter_sticky);
        window.addEventListener("scroll", init_filter_sticky, {
          passive: true,
        });
      } else {
        window.removeEventListener("scroll", init_filter_sticky);
        $(".toolbar.top_toolbar")
          .removeClass("sticky")
          .css("top", "")
          .prev(".filter-placeholder")
          .css("height", "");
      }
    });
  }
});

jQuery(function ($) {
  $(".block-title .apply-btn-mob button").click(function () {
    $(".filter-form").trigger("submit");
  });

  $(".canvas-icon.sicon-left, .close-left").click(function (event) {
    if (!$("body").hasClass("canvas-left")) {
      $("body").addClass("mobile-canvas-shown");
      $("body").addClass("canvas-left", function () {
        setTimeout(function () {
          $(document).one("click", function (e) {
            var target = e.target;
            if (
              !$(target).is(".canvas-left .block") &&
              !$(target).parents().is(".canvas-left .canvas-inner")
            ) {
              $("body").removeClass("canvas-left");
              $("body").removeClass("mobile-canvas-shown");
            }
          });
        }, 111);
      });
    } else {
      $("body").removeClass("canvas-left");
      $("body").removeClass("mobile-canvas-shown");
    }
  });
});

jQuery(document).ready(function ($) {
  $(".nav-categories li").each(function () {
    if ($(this).hasClass("active")) {
      $(this).parents("li").addClass("active");
    }
  });
});

// Filter
$(".active-filters").appendTo(
  ".collection-sorting-row .filter_wrap .applied-filter-content"
);

$(function () {
  $("#slider-range").slider({
    range: true,
    min: parseInt(
      $(".filter-group-display__price-range-from input").attr("min")
    ),
    max: parseInt($(".filter-group-display__price-range-to input").attr("max")),
    values: [
      parseInt($(".filter-group-display__price-range-from input").val()),
      parseInt($(".filter-group-display__price-range-to input").val()),
    ],
    slide: function (event, ui) {
      $(".filter-group-display__price-range-from input").val(
        `${shop_currency} ` + ui.values[0]
      );
      $(".filter-group-display__price-range-to input").val(
        `${shop_currency} ` + ui.values[1]
      );
    },
  });
  $(".filter-group-display__price-range-from input").val(
    `${shop_currency} ` + $("#slider-range").slider("values", 0)
  );
  $(".filter-group-display__price-range-to input").val(
    `${shop_currency} ` + $("#slider-range").slider("values", 1)
  );
});

// Grid - List View
jQuery(document).ready(function ($) {
  if (window.location.href.indexOf("view=list") > -1) {
    $(".template-collection .category-products").removeClass("grid").addClass("list");
    $(".template-collection .view-mode .icon-mode-grid").removeClass("active");
    $(".template-collection .view-mode .icon-mode-list").addClass("active");
  }
  if (localStorage.getItem("view")) {
    if (localStorage.getItem("view") == "list") {
      $(".template-collection .category-products").removeClass("grid").addClass("list");
      $(".template-collection .view-mode .icon-mode-grid").removeClass("active");
      $(".template-collection .view-mode .icon-mode-list").addClass("active");
    } else {
      $(".template-collection .category-products").removeClass("list").addClass("grid");
      $(".template-collection .view-mode .icon-mode-list").removeClass("active");
      $(".template-collection .view-mode .icon-mode-grid").addClass("active");
    }
  }

  $(".view-mode a")
    .eq(0)
    .click(function (e) {
      e.preventDefault();
      $("#resultLoading").show();
      setTimeout(function () {
        localStorage.setItem("view", "grid");
        $(".category-products").removeClass("list").addClass("grid");
        $(".view-mode .icon-mode-list").removeClass("active");
        $(".view-mode .icon-mode-grid").addClass("active");
        $("#resultLoading").hide();
      }, 500);
    });
  $(".view-mode a")
    .eq(1)
    .click(function (e) {
      e.preventDefault();
      $("#resultLoading").show();
      setTimeout(function () {
        localStorage.setItem("view", "list");
        $(".category-products").removeClass("grid").addClass("list");
        $(".view-mode .icon-mode-grid").removeClass("active");
        $(".view-mode .icon-mode-list").addClass("active");
        $("#resultLoading").hide();
      }, 500);
    });
});

// Product Grid review

function productGridReview() {
  jQuery(document).ready(function ($) {
  $("#products-grid .item .product-inner").each(function () {
    let targetThis = $(this).find(".product-content .jdgm-preview-badge")[0];
    if (targetThis) {
      let no_of_reviews = parseInt(
        $(this)
          .find(".product-content .jdgm-preview-badge .jdgm-prev-badge")
          .attr("data-number-of-reviews")
      );
      if (no_of_reviews < 1) {
        $(
          '<div class="rt-first-review-link"><span>Be the first one  to review! <span style="text-decoration: underline;">Click here now</span></span></div>'
        ).insertBefore($(this).find(".product-content .jdgm-preview-badge"));
      }
    }
  });
});
}
productGridReview();
// Search Box in Filter
jQuery(document).ready(function ($) {
  $(".filter-group").each(function () {
    var mainThis = $(this);
    mainThis
      .find(".custom-filter-search-box .search_field-filter")
      .on("keyup", function () {
        var value = $(this).val();
        var patt = new RegExp(value, "i");
        mainThis
          .find(".filter-group-display__list .filter-group-display__list-item")
          .hide();
        mainThis
          .find(".filter-group-display__list .filter-group-display__list-item")
          .each(function () {
            var listVal = $(this);
            if (listVal.find("label").text().search(patt) >= 0) {
              listVal.show();
            }
          });
      });
  });
});

// Prof Review display higest
// jQuery(document).ready(function ($) {
//   $(".template-collection #products-grid .item.product").each(function () {
//     let self = $(this);
//     let largest = parseInt(
//       self
//         .find(".prof_rating .wine-rating-box")
//         .first()
//         .find(".wine-rating-number")
//         .text()
//     );
//     if (largest) {
//       self.find(".prof_rating .wine-rating-box").each(function () {
//         let me = $(this);
//         let rating_no = parseInt(me.find(".wine-rating-number").text());
//         if (largest < rating_no) {
//           largest = rating_no;
//         }
//       });
//       self.find(".prof_rating .wine-rating-box").each(function () {
//         if (parseInt($(this).find(".wine-rating-number").text()) == largest) {
//           // console.log($(this).find(".rating-name").text(), largest);
//           htmlRting = `
//                   <div class="product-rating-container list only-collection-search-page">
//                       <div class="product-rating-list ">
//                           <div class="wine-rating-box">
//                               <div class="wine-rating-content">                  
//                                   <span class="rating-name">${$(this)
//                                     .find(".rating-name")
//                                     .text()}</span>
//                               </div>
//                               <div class="wine-rating-number">${largest}</div>
//                           </div>
//                       </div>
//                   </div>`;
//           self.find(".prof_rating .product-rating-container.list").remove();
//           $(htmlRting).appendTo(self.find(".prof_rating"));
//         }
//       });
//     }
//   });
// });
